import Phaser from 'phaser';
import { GAME_WIDTH, GAME_HEIGHT } from '@/config/gameConfig';
import { THEME } from '@/config/theme';
import { loadSettings, getBackgroundConfig } from '@/config/settings';

/**
 * Draws background image with dark overlay.
 */
export function drawArcadeBackground(scene: Phaser.Scene): void {
  const settings = loadSettings();
  const bgConfig = getBackgroundConfig(settings.background);

  // Background image
  const bg = scene.add.image(GAME_WIDTH / 2, GAME_HEIGHT / 2, `bg-${bgConfig.id}`);
  bg.setDisplaySize(GAME_WIDTH, GAME_HEIGHT);
  bg.setDepth(-5);

  // Dark overlay
  const overlay = scene.add.graphics();
  overlay.setDepth(-4);
  overlay.fillStyle(0x000000, bgConfig.darkness);
  overlay.fillRect(0, 0, GAME_WIDTH, GAME_HEIGHT);
}

/**
 * Adds a glow effect to text using shadow
 */
export function addTextGlow(
  text: Phaser.GameObjects.Text,
  color: string = THEME.colors.cyan,
  blur: number = 10,
  _strength: number = 1
): void {
  // Phaser's setShadow creates a glow effect when blur is used
  text.setShadow(0, 0, color, blur, true, true);
}
